import { useRef, useEffect } from "react";
const useInitialization = ({
  onChange,
  getAddress,
  searchBy
}) => {
  const placeId = searchBy && "placeId" in searchBy ? searchBy.placeId : void 0, { lat, lng } = searchBy && "lat" in searchBy ? searchBy : {}, value = searchBy && "value" in searchBy ? searchBy.value : void 0, refs = useRef({ onChange });
  refs.current = {
    onChange
  }, useEffect(() => {
    (async () => {
      if (!getAddress || !placeId && !lat && !lng && !value)
        return;
      let searchParams;
      if (placeId && (searchParams = { placeId }), lat && lng && (searchParams = { location: { lat, lng } }), value && (searchParams = { address: value }), !searchParams)
        return;
      const address = await getAddress(searchParams);
      address && refs.current.onChange(address);
    })();
  }, [getAddress, lat, lng, placeId, value]);
};
export {
  useInitialization
};
//# sourceMappingURL=useInitialization.js.map
